import { secondsToDisplayHours, secondsToHoursAndMinutesString, secondsToTimeString } from '@/helpers/dateHelper';
import { FC } from 'react';
import { useRosterDayStats } from '../providers/WorkingRosterService';
import strings from '../roster.translations';

type StatCardProps = {
  label: string;
  value: React.ReactNode;
};

const StatCard: FC<StatCardProps> = ({ label, value }) => (
  <div className="border-2 rounded-md p-2 w-60">
    <span className="font-semibold">{label}</span>
    <div>{value}</div>
  </div>
);

export const RosterSummary: FC = () => {
  const rosterSummary = useRosterDayStats();

  const stats = [
    {
      label: strings.drawer.summary.timeWorked,
      value: secondsToHoursAndMinutesString(rosterSummary.actualTotal)
    },
    {
      label: strings.drawer.summary.totalStaffRostered,
      value: rosterSummary.totalStaffRostered
    },
    {
      label: strings.drawer.summary.totalShifts,
      value: rosterSummary.totalShifts
    }
  ];

  return (
    <div className="flex gap-3 mt-3">
      {stats.map(s => (
        <StatCard key={s.label} label={s.label} value={s.value} />
      ))}
    </div>
  );
};
